
const crypto = require('crypto');

function buildSignature(params) {
  try {
    // 从 window.GOV_MO.CLIENT_ID 获取 nonce 值
    const nonce = window.GOV_MO.CLIENT_ID;
    // 创建一个新的参数对象用于签名，避免修改原始对象
    const paramsForSigning = { ...params, nonce };
    // 排序并构建待签名字符串
    const sortedKeys = Object.keys(paramsForSigning).sort();
    const stringToSign = sortedKeys
      .map(key => `${key}=${paramsForSigning[key]}`)
      .join('&');
    // 2. SHA256 加密
    const hash = crypto.createHash('sha256');
    hash.update(stringToSign, 'utf8');
    const signature = hash.digest('hex');
    // 返回包含签名但不包含nonce的参数对象
    return { ...params, signature };
  } catch (e) {
    console.error(e);
    return null;
  }
}

// 导出 buildSignature 函数，使其可以在其他地方调用
export { buildSignature };
